import { useState } from 'react';
import dayjs from 'dayjs';
import { FileText, Folder, Plus } from 'lucide-react';

import { useProjects } from '@/api/project/use-projects.ts';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty.tsx';
import AppContent from '@/layout/app-content.tsx';
import CreateProjectModal from '../../features/projects/create-project-modal/create-project-modal.tsx';

const Home = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data: projects } = useProjects();

  return (
    <AppContent title="Dashboard">
      {!projects?.length ? (
        <Empty>
          <EmptyHeader>
            <EmptyMedia variant="icon">
              <Folder />
            </EmptyMedia>
            <EmptyTitle>No Projects Yet</EmptyTitle>
            <EmptyDescription>
              You haven&apos;t created any projects yet. Get started by creating your first project.
            </EmptyDescription>
          </EmptyHeader>
          <EmptyContent>
            <Button onClick={() => setIsModalOpen(true)}>Create Project</Button>
          </EmptyContent>
        </Empty>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {projects?.map((project) => (
            <Card key={project.uuid} className="group hover:shadow-md transition-shadow">
              <CardHeader>
                <div className="flex items-center gap-2">
                  <FileText className="w-4 h-4 text-primary" />
                  <CardTitle className="text-sm">{project.name}</CardTitle>
                </div>
              </CardHeader>
              <CardContent>
                <CardDescription>
                  Created: {dayjs(project.createdAt).format('DD.MM.YYYY')}
                </CardDescription>
              </CardContent>
              <CardFooter>
                <Button variant="outline" className="w-full">
                  View Project
                </Button>
              </CardFooter>
            </Card>
          ))}
          <Card
            onClick={() => setIsModalOpen(true)}
            className="border-2 border-dashed border-muted-foreground/20 hover:border-muted-foreground/40 hover:shadow-md transition-all cursor-pointer group min-h-[200px]"
          >
            <CardContent className="flex items-center justify-center h-full min-h-[168px]">
              <div className="text-center space-y-3">
                <div className="w-12 h-12 bg-muted rounded-full flex items-center justify-center mx-auto group-hover:bg-muted/80 transition-colors">
                  <Plus className="w-6 h-6 text-muted-foreground" />
                </div>
                <CardTitle className="text-sm text-muted-foreground">Create New Project</CardTitle>
                <CardDescription>Add a new expense project</CardDescription>
              </div>
            </CardContent>
          </Card>
        </div>
      )}
      {isModalOpen && <CreateProjectModal onClose={() => setIsModalOpen(false)} />}
    </AppContent>
  );
};

export default Home;
